export default __webpack_public_path__ + "static/media/smiley.a4da3123.png";